import { render, staticRenderFns } from "./RepetitionsSwitch.vue?vue&type=template&id=72962c69&scoped=true&"
import script from "./RepetitionsSwitch.vue?vue&type=script&lang=ts&"
export * from "./RepetitionsSwitch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72962c69",
  null
  
)

export default component.exports